module.exports = __webpack_public_path__ + "img/Katarina_home_hero.51c63416.jpg";